// Use the existing v4 CSS setup as the source of truth, including runtime overrides.
// Shades derive from those variables; no separate brand hex palette lives here.
export const autoflowColors = {
  // v4's black/white values also cover shells that omit Bootstrap's aliases.
  ink: 'var(--bs-black, #000000)',
  white: 'var(--bs-white, #ffffff)',
  primary: 'var(--autoflow-primary-color)',
  success: 'var(--autoflow-success-color)',
  danger: 'var(--autoflow-danger-color)',
  warn: 'var(--autoflow-warning-color)',
  info: 'var(--autoflow-primary-color)',
};

export const autoflowScale = (color) =>
  Object.fromEntries(
    [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].map((shade) => [
      shade,
      shade === 500
        ? color
        : `color-mix(in srgb, ${color} ${shade < 500 ? shade / 5 : (1000 - shade) / 5}%, var(--bs-${shade < 500 ? 'white' : 'black'}))`,
    ]),
  );
